import React from "react";

export const DashBoardIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    className="svg-icon" // Apply the hover effect class
  >
    <path
      d="M6.83594 17.3324L10.7455 12.2511L15.2051 15.7542L19.0311 10.8164"
      stroke="#4d4e50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="23.4873"
      cy="3.51076"
      r="2.51076"
      stroke="#4d4e50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8656 2.10254H7.37255C3.43902 2.10254 1 4.88829 1 8.82181V19.379C1 23.3125 3.3912 26.0863 7.37255 26.0863H18.6112C22.5447 26.0863 24.9837 23.3125 24.9837 19.379V10.1848"
      stroke="#4d4e50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const StudentsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="28"
    viewBox="0 0 230 230"
    fill="none"
    className="svg-icon"
  >
    <path
      d="M223.336,148.384l-0.137-23.527l22.628-12.662L122.576,47.195L0,113.495l49.144,28.216
         l0.098,16.766l0.01,1.339l0.449-0.215c-0.518,0.703-0.85,1.426-0.84,2.149c0.039,8.246,33.326,14.772,74.41,14.548
         c41.064-0.215,74.302-7.122,74.273-15.349c0-0.723-0.381-1.426-0.889-2.149l0.449,0.215v-1.339l-0.088-16.834l21.309-13.258
         l0.117,20.83c-2.345,1.006-3.976,3.312-3.957,6.009c0.02,3.537,2.892,6.399,6.458,6.37c3.586-0.02,6.429-2.912,6.409-6.439
         C227.332,151.657,225.691,149.371,223.336,148.384z M123.241,170.621c-36.452,0.205-66.017-3.801-66.046-8.91
         c-0.029-5.11,29.496-9.399,65.949-9.585c36.462-0.205,66.017,3.781,66.037,8.881
         C189.209,166.098,159.703,170.426,123.241,170.621z M195.335,127.183c-4.934-5.188-22.618-18.886-72.426-18.602
         c-49.877,0.264-67.336,14.128-72.211,19.394l-0.029-4.963c0,0,14.147-21.524,72.202-21.827
         c58.025-0.313,72.436,21.045,72.436,21.045L195.335,127.183z M215.755,162.199l-2.511,36.433
         c7.767-12.203,14.255-7.66,14.255-7.66l-0.156-28.832C218.998,165.414,215.755,162.199,215.755,162.199z"
      stroke="#4d4e50"
      strokeWidth="12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BillingIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    className="svg-icon" // Apply the hover effect class
  >
    <mask
      id="mask0_1284_5425"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="25"
    >
      <rect
        x="0.5"
        y="0.5"
        width="24"
        height="24"
        fill="#D9D9D9"
        stroke="rgba(77, 78, 80, 0.8)"
      />
    </mask>
    <g mask="url(#mask0_1284_5425)">
      <path
        d="M9.41085 10.2876C9.3765 10.5797 9.44516 10.8368 9.61668 11.0598C9.78814 11.2827 10.0194 11.4112 10.3114 11.4456C10.6034 11.48 10.8605 11.4113 11.0835 11.2398C11.3064 11.0683 11.435 10.837 11.4694 10.5451L11.4694 10.5449L11.7558 8.35743L11.7573 8.34655H11.7682H15.9089H15.9229L15.9213 8.36054L15.6869 10.3136C15.6869 10.3136 15.6869 10.3137 15.6869 10.3137M9.41085 10.2876L17.7318 10.5726C17.6971 10.8677 17.5668 11.0978 17.3411 11.2627C17.1155 11.4276 16.855 11.4927 16.5599 11.458C16.2648 11.4233 16.0347 11.2974 15.8698 11.0804C15.7049 10.8634 15.6398 10.6073 15.6745 10.3122L15.6869 10.3137M9.41085 10.2876C9.41085 10.2876 9.41085 10.2876 9.41085 10.2876L9.64522 8.36056L9.64693 8.34655H9.63281H5.74065C5.8117 7.76484 6.03578 7.27289 6.41277 6.8702C6.79237 6.46472 7.25782 6.26217 7.8099 6.26217H9.89323H9.90447L9.90566 6.251C10.0443 4.95109 10.4904 3.93408 11.2431 3.19872C11.9955 2.46366 13.0207 2.09551 14.3203 2.09551C15.4279 2.09551 16.349 2.50633 17.0844 3.32832C17.8201 4.15058 18.1793 5.12408 18.162 6.24948L18.1618 6.26217H18.1745H20.8306C21.452 6.27948 21.9695 6.52101 22.3839 6.98715C22.7981 7.45314 22.9619 7.99635 22.8756 8.61775L22.8756 8.61792L21.3131 21.1178C21.3131 21.1178 21.3131 21.1179 21.3131 21.1179C21.2441 21.6357 21.0155 22.0626 20.6272 22.3991C20.2389 22.7356 19.7861 22.9038 19.2682 22.9038H6.2474C5.67782 22.9038 5.19054 22.7012 4.78488 22.2955C4.38219 21.8928 4.17954 21.4097 4.1766 20.8455H19.3464H19.3574L19.3588 20.8346L19.8796 16.6679L19.8796 16.6678L20.2727 13.4147L20.8952 8.361L20.8952 8.36062L20.8952 8.36058L20.8969 8.34655H20.8828H18.0182H18.0072L18.0058 8.35745L17.7194 10.571L17.7194 10.5711C17.685 10.8631 17.5565 11.0899 17.3338 11.2526C17.1108 11.4155 16.8536 11.48 16.5614 11.4456C16.2693 11.4112 16.0424 11.2869 15.8797 11.0728C15.717 10.8587 15.6525 10.6059 15.6869 10.3137M9.41085 10.2876L15.6869 10.3137M11.9641 6.24833L11.9626 6.26217H11.9766H16.1172H16.1293L16.1297 6.25005C16.1471 5.67367 15.9505 5.17989 15.5401 4.76948C15.1298 4.35917 14.6362 4.15384 14.0599 4.15384C13.4495 4.15384 12.9642 4.34143 12.6055 4.71761C12.2473 5.09332 12.0338 5.60394 11.9641 6.24833ZM6.75847 18.7372H1.05507L1.56966 16.6788H7.27305L6.75847 18.7372ZM9.88347 14.5705H3.13841L3.65299 12.5122H10.3981L9.88347 14.5705Z"
        fill="rgba(77, 78, 80, 0.8)"
        stroke="rgba(77, 78, 80, 0.8)"
        strokeWidth="0.025"
      />
    </g>
  </svg>
);

export const ServiceProviderIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M11.925 8.475L7.675 4.225L9.1 2.825L11.925 5.65L17.6 0L19 1.4L11.925 8.475ZM6 15.925L12.95 17.825L18.9 15.975C18.8167 15.825 18.6958 15.6958 18.5375 15.5875C18.3792 15.4792 18.2 15.425 18 15.425H12.95C12.5 15.425 12.1417 15.4083 11.875 15.375C11.6083 15.3417 11.3333 15.275 11.05 15.175L8.725 14.4L9.275 12.45L11.3 13.125C11.5833 13.2083 11.9167 13.275 12.3 13.325C12.6833 13.375 13.25 13.4083 14 13.425C14 13.2417 13.9458 13.0667 13.8375 12.9C13.7292 12.7333 13.6 12.625 13.45 12.575L7.6 10.425H6V15.925ZM0 19.425V8.425H7.6C7.71667 8.425 7.83333 8.4375 7.95 8.4625C8.06667 8.4875 8.175 8.51667 8.275 8.55L14.15 10.725C14.7 10.925 15.1458 11.275 15.4875 11.775C15.8292 12.275 16 12.825 16 13.425H18C18.8333 13.425 19.5417 13.7 20.125 14.25C20.7083 14.8 21 15.525 21 16.425V17.425L13 19.925L6 17.975V19.425H0ZM2 17.425H4V10.425H2V17.425Z"
      fill="#396B61"
    />
  </svg>
);

export const SettingsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M9.42988 25L8.92334 20.9918C8.56703 20.8738 8.20163 20.7086 7.82713 20.4961C7.45286 20.2833 7.11817 20.0556 6.82305 19.8128L3.06979 21.3816L0 16.1184L3.24639 13.6918C3.2158 13.4962 3.19407 13.2997 3.18121 13.1023C3.16835 12.9049 3.16192 12.7083 3.16192 12.5125C3.16192 12.3254 3.16835 12.1353 3.18121 11.9421C3.19407 11.7489 3.2158 11.5376 3.24639 11.3082L0 8.88158L3.06979 3.64375L6.81008 5.2C7.13092 4.94868 7.47337 4.71886 7.83744 4.51053C8.20152 4.30219 8.55927 4.13476 8.91071 4.00822L9.42988 0H15.5701L16.0767 4.02072C16.4758 4.16414 16.8368 4.33158 17.1599 4.52303C17.4832 4.71447 17.8094 4.94013 18.1387 5.2L21.9302 3.64375L25 8.88158L21.7024 11.3461C21.7501 11.5586 21.7761 11.7572 21.7805 11.9421C21.7848 12.1268 21.7869 12.3127 21.7869 12.5C21.7869 12.6787 21.7825 12.8605 21.7739 13.0454C21.7655 13.23 21.7349 13.4413 21.6821 13.6793L24.9541 16.1184L21.884 21.3816L18.1387 19.8C17.8094 20.0599 17.4734 20.2897 17.1306 20.4895C16.7878 20.6895 16.4365 20.8527 16.0767 20.9793L15.5701 25H9.42988ZM11.1696 23.0263H13.7845L14.2627 19.5016C14.9416 19.3262 15.562 19.077 16.1239 18.7539C16.686 18.4307 17.228 18.0152 17.7499 17.5076L21.0552 18.8816L22.3652 16.6447L19.4794 14.4941C19.5902 14.1533 19.6656 13.8192 19.7055 13.4918C19.7457 13.1646 19.7657 12.834 19.7657 12.5C19.7657 12.1575 19.7457 11.8269 19.7055 11.5082C19.6656 11.1894 19.5902 10.8637 19.4794 10.5313L22.3905 8.35526L21.0808 6.11842L17.7369 7.5125C17.2917 7.04189 16.7583 6.6261 16.1369 6.26513C15.5151 5.90417 14.8862 5.64858 14.2501 5.49836L13.8304 1.97368H11.1903L10.7499 5.48586C10.0712 5.64441 9.44451 5.88728 8.8698 6.21447C8.29486 6.54189 7.74643 6.9636 7.22448 7.47961L3.91922 6.11842L2.60949 8.35526L5.48239 10.473C5.37152 10.7853 5.29392 11.1101 5.24957 11.4474C5.20523 11.7846 5.18306 12.1397 5.18306 12.5125C5.18306 12.855 5.20523 13.1908 5.24957 13.5197C5.29392 13.8487 5.36731 14.1735 5.46975 14.4941L2.60949 16.6447L3.91922 18.8816L7.21184 17.5C7.71671 18.0127 8.2565 18.4328 8.83122 18.7602C9.40615 19.0874 10.0415 19.3387 10.7373 19.5141L11.1696 23.0263ZM12.5153 16.4474C13.6222 16.4474 14.564 16.0632 15.341 15.2947C16.1179 14.5263 16.5064 13.5947 16.5064 12.5C16.5064 11.4053 16.1179 10.4737 15.341 9.70526C14.564 8.93684 13.6222 8.55263 12.5153 8.55263C11.3947 8.55263 10.4494 8.93684 9.67932 9.70526C8.90926 10.4737 8.52424 11.4053 8.52424 12.5C8.52424 13.5947 8.90926 14.5263 9.67932 15.2947C10.4494 16.0632 11.3947 16.4474 12.5153 16.4474Z"
      fill="#4d4e50"
    />
  </svg>
);
export const OrganizationIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <mask
      id="mask0_1284_5431"
      style={{ maskType: "alpha" }} // Correct way to write style in JSX
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect width="21" height="21" fill="#4d4e50" />
    </mask>
    <g mask="url(#mask0_1284_5431)">
      <path
        d="M4.375 14.875V8.75H6.125V14.875H4.375ZM9.625 14.875V8.75H11.375V14.875H9.625ZM1.75 18.375V16.625H19.25V18.375H1.75ZM14.875 14.875V8.75H16.625V14.875H14.875ZM1.75 7V5.25L10.5 0.875L19.25 5.25V7H1.75ZM5.64375 5.25H15.3562L10.5 2.84375L5.64375 5.25Z"
        fill="#4d4e50"
      />
    </g>
  </svg>
);

export const PersonalDetailsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <mask
      id="mask0_1284_5428"
      style={{ maskType: "alpha" }} // Correct way to write style in JSX
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect width="21" height="21" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1284_5428)">
      <path
        d="M8.75 10.5C7.7875 10.5 6.96354 10.1573 6.27812 9.47188C5.59271 8.78646 5.25 7.9625 5.25 7C5.25 6.0375 5.59271 5.21354 6.27812 4.52813C6.96354 3.84271 7.7875 3.5 8.75 3.5C9.7125 3.5 10.5365 3.84271 11.2219 4.52813C11.9073 5.21354 12.25 6.0375 12.25 7C12.25 7.9625 11.9073 8.78646 11.2219 9.47188C10.5365 10.1573 9.7125 10.5 8.75 10.5ZM1.75 17.5V15.05C1.75 14.5687 1.87396 14.1167 2.12187 13.6938C2.36979 13.2708 2.7125 12.95 3.15 12.7312C3.89375 12.3521 4.73229 12.0312 5.66562 11.7688C6.59896 11.5062 7.62708 11.375 8.75 11.375H9.05625C9.14375 11.375 9.23125 11.3896 9.31875 11.4188C9.20208 11.6813 9.10365 11.9547 9.02344 12.2391C8.94323 12.5234 8.88125 12.8188 8.8375 13.125H8.75C7.71458 13.125 6.7849 13.2562 5.96094 13.5188C5.13698 13.7812 4.4625 14.0438 3.9375 14.3063C3.80625 14.3792 3.70052 14.4812 3.62031 14.6125C3.5401 14.7437 3.5 14.8896 3.5 15.05V15.75H9.0125C9.1 16.0562 9.21667 16.3589 9.3625 16.6578C9.50833 16.9568 9.66875 17.2375 9.84375 17.5H1.75ZM14 18.375L13.7375 17.0625C13.5625 16.9896 13.3984 16.913 13.2453 16.8328C13.0922 16.7526 12.9354 16.6542 12.775 16.5375L11.5062 16.9313L10.6312 15.4438L11.6375 14.5688C11.6083 14.3646 11.5937 14.175 11.5937 14C11.5937 13.825 11.6083 13.6354 11.6375 13.4313L10.6312 12.5563L11.5062 11.0688L12.775 11.4625C12.9354 11.3458 13.0922 11.2474 13.2453 11.1672C13.3984 11.087 13.5625 11.0104 13.7375 10.9375L14 9.625H15.75L16.0125 10.9375C16.1875 11.0104 16.3516 11.0906 16.5047 11.1781C16.6578 11.2656 16.8146 11.375 16.975 11.5063L18.2437 11.0688L19.1187 12.6L18.1125 13.475C18.1417 13.65 18.1562 13.8323 18.1562 14.0219C18.1562 14.2115 18.1417 14.3938 18.1125 14.5688L19.1187 15.4438L18.2437 16.9313L16.975 16.5375C16.8146 16.6542 16.6578 16.7526 16.5047 16.8328C16.3516 16.913 16.1875 16.9896 16.0125 17.0625L15.75 18.375H14ZM14.875 15.75C15.3562 15.75 15.7682 15.5786 16.1109 15.2359C16.4536 14.8932 16.625 14.4812 16.625 14C16.625 13.5188 16.4536 13.1068 16.1109 12.7641C15.7682 12.4214 15.3562 12.25 14.875 12.25C14.3937 12.25 13.9818 12.4214 13.6391 12.7641C13.2964 13.1068 13.125 13.5188 13.125 14C13.125 14.4812 13.2964 14.8932 13.6391 15.2359C13.9818 15.5786 14.3937 15.75 14.875 15.75ZM8.75 8.75C9.23125 8.75 9.64323 8.57865 9.98594 8.23594C10.3286 7.89323 10.5 7.48125 10.5 7C10.5 6.51875 10.3286 6.10677 9.98594 5.76406C9.64323 5.42135 9.23125 5.25 8.75 5.25C8.26875 5.25 7.85677 5.42135 7.51406 5.76406C7.17135 6.10677 7 6.51875 7 7C7 7.48125 7.17135 7.89323 7.51406 8.23594C7.85677 8.57865 8.26875 8.75 8.75 8.75Z"
        fill="#4d4e50"
      />
    </g>
  </svg>
);
export const PlatformProvidersIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <mask
      id="mask0_1284_5422"
      style={{ maskType: "alpha" }} // Correct way to write style in JSX
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect width="21" height="21" fill="#4d4e50" />
    </mask>
    <g mask="url(#mask0_1284_5422)">
      <path
        d="M3.5 15.75V5.25V16.625V15.75ZM3.5 17.5C3.01875 17.5 2.60677 17.3286 2.26406 16.9859C1.92135 16.6432 1.75 16.2312 1.75 15.75V5.25C1.75 4.76875 1.92135 4.35677 2.26406 4.01406C2.60677 3.67135 3.01875 3.5 3.5 3.5H8.75L10.5 5.25H17.5C17.9813 5.25 18.3932 5.42135 18.7359 5.76406C19.0786 6.10677 19.25 6.51875 19.25 7V11.375H17.5V7H9.77812L8.02813 5.25H3.5V15.75H7.875V17.5H3.5ZM12.775 19.775L9.625 16.625L12.775 13.475L14 14.7219L12.0969 16.625L14 18.5281L12.775 19.775ZM16.975 19.775L15.75 18.5281L17.6531 16.625L15.75 14.7219L16.975 13.475L20.125 16.625L16.975 19.775Z"
        fill="#4d4e50"
      />
    </g>
  </svg>
);
export const UserControlsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5006 11.9579L12.6302 11.9579L12.9203 11.9589C15.1371 11.9735 20.2031 12.1975 20.2031 15.6312C20.2031 19.0423 15.3137 19.2648 12.9548 19.2793L12.0809 19.2793C9.86394 19.2647 4.79694 19.0411 4.79694 15.6116C4.79694 12.1962 9.86394 11.9734 12.0809 11.9589L12.3709 11.9579C12.4159 11.9579 12.4592 11.9579 12.5006 11.9579ZM12.5006 13.6803C9.77232 13.6803 6.51932 14.0156 6.51932 15.6116C6.51932 17.1716 9.57816 17.5363 12.2512 17.557L12.5006 17.5579C15.2288 17.5579 18.4807 17.2238 18.4807 15.6312C18.4807 14.019 15.2288 13.6803 12.5006 13.6803ZM21.6333 11.4919C24.4155 11.9088 25 13.2155 25 14.2386C25 14.8632 24.7543 16.0034 23.1123 16.6292C23.0112 16.6671 22.9079 16.6855 22.8057 16.6855C22.4589 16.6855 22.1317 16.4742 22.0008 16.1309C21.8308 15.6865 22.0547 15.1882 22.4991 15.0194C23.2776 14.7231 23.2776 14.3959 23.2776 14.2386C23.2776 13.7356 22.638 13.3843 21.3773 13.196C20.9076 13.1248 20.5827 12.6873 20.6527 12.2153C20.7228 11.7446 21.1591 11.4311 21.6333 11.4919ZM4.34729 12.2153C4.41733 12.6873 4.09237 13.1248 3.62274 13.196C2.36196 13.3843 1.72238 13.7356 1.72238 14.2386C1.72238 14.3959 1.72238 14.722 2.50204 15.0194C2.94642 15.1882 3.17033 15.6865 3.00039 16.1309C2.86948 16.4742 2.54223 16.6855 2.19546 16.6855C2.09327 16.6855 1.98992 16.6671 1.88888 16.6292C0.245726 16.0023 0 14.8621 0 14.2386C0 13.2166 0.584461 11.9088 3.36783 11.4919C3.84206 11.4322 4.27609 11.7446 4.34729 12.2153ZM12.5006 0C15.3942 0 17.7469 2.35392 17.7469 5.24637C17.7469 8.13882 15.3942 10.4927 12.5006 10.4927H12.4696C11.0687 10.4881 9.75625 9.93928 8.77334 8.94719C7.78814 7.95625 7.24961 6.64035 7.25531 5.24292C7.25531 2.35392 9.60812 0 12.5006 0ZM12.5006 1.72238C10.5577 1.72238 8.97771 3.30352 8.97771 5.24637C8.97429 6.18794 9.33484 7.06865 9.99508 7.73348C10.6553 8.39832 11.5349 8.76691 12.4719 8.77036L12.5006 9.63155V8.77036C14.4434 8.77036 16.0246 7.19036 16.0246 5.24637C16.0246 3.30352 14.4434 1.72238 12.5006 1.72238ZM19.6071 1.12471C21.6257 1.45656 23.0921 3.18353 23.0921 5.23087C23.0875 7.29198 21.5477 9.06029 19.5095 9.34621C19.4693 9.35195 19.4291 9.35424 19.3901 9.35424C18.9675 9.35424 18.5989 9.04307 18.5381 8.61247C18.4726 8.14054 18.7999 7.70535 19.2718 7.6399C20.466 7.47226 21.3674 6.43653 21.3697 5.22857C21.3697 4.03094 20.5108 3.01818 19.3269 2.82413C18.8585 2.7472 18.5404 2.30397 18.6173 1.83433C18.6954 1.3647 19.1352 1.05008 19.6071 1.12471ZM6.38383 1.83433C6.46076 2.30397 6.14269 2.7472 5.67421 2.82413C4.49036 3.01818 3.63147 4.03094 3.63147 5.23087C3.63376 6.43653 4.53514 7.47341 5.72818 7.6399C6.20011 7.70535 6.52736 8.14054 6.46191 8.61247C6.40105 9.04307 6.03246 9.35424 5.60991 9.35424C5.57087 9.35424 5.53068 9.35195 5.49049 9.34621C3.45234 9.06029 1.91368 7.29198 1.90909 5.23316C1.90909 3.18353 3.37541 1.45656 5.39403 1.12471C5.87745 1.04893 6.30575 1.367 6.38383 1.83433Z"
      fill="#4d4e50"
    />
  </svg>
);
export const UsersIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
  >
    <path
      d="M15.1319 6.35294C15.1319 9.39197 12.444 11.9559 8.99954 11.9559C5.55508 11.9559 2.86719 9.39197 2.86719 6.35294C2.86719 3.31392 5.55508 0.75 8.99954 0.75C12.444 0.75 15.1319 3.31392 15.1319 6.35294Z"
      stroke="#4d4e50"
      stroke-width="1.5"
    />
    <path
      d="M17.25 18.415C17.25 19.2206 16.5775 20.1517 15.0286 20.9262C13.5245 21.6782 11.3941 22.165 9 22.165C6.60591 22.165 4.47554 21.6782 2.97145 20.9262C1.4225 20.1517 0.75 19.2206 0.75 18.415C0.75 17.6095 1.4225 16.6784 2.97145 15.9039C4.47554 15.1518 6.60591 14.665 9 14.665C11.3941 14.665 13.5245 15.1518 15.0286 15.9039C16.5775 16.6784 17.25 17.6095 17.25 18.415Z"
      stroke="#4d4e50"
      stroke-width="1.5"
    />
  </svg>
);
export const RolesIcon: React.FC = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 25.2105C8.47203 24.4878 5.9651 22.9278 3.9792 20.5307C1.99307 18.1335 1 15.4535 1 12.4907V5.44042L11.5 2L22 5.44042V12.4907C22 15.4535 21.0069 18.1335 19.0208 20.5307C17.0349 22.9278 14.528 24.4878 11.5 25.2105Z"
      stroke="#4d4e50"
      stroke-width="2"
    />
  </svg>
);

export const FileUploadIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="30"
    viewBox="0 0 23 30"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.8254 4.25926C1.8254 2.9297 2.88781 1.85185 4.19841 1.85185H14.9683V6.48148C14.9683 7.60652 15.8672 8.51852 16.9762 8.51852H21.1746V25.7407C21.1746 27.0703 20.1122 28.1481 18.8016 28.1481H4.19841C2.88781 28.1481 1.8254 27.0703 1.8254 25.7407V4.25926ZM20.5986 6.66667L19.6266 5.60707L16.7937 2.78989V6.48148C16.7937 6.58374 16.8754 6.66667 16.9762 6.66667H20.5986ZM4.19841 0C1.87968 0 0 1.90693 0 4.25926V25.7407C0 28.0931 1.87968 30 4.19841 30H18.8016C21.1203 30 23 28.0931 23 25.7407V7.95015C23 7.0607 22.668 6.2043 22.0707 5.55318L20.9486 4.32993L20.9343 4.31437L20.9194 4.29948L17.6073 1.00581C16.959 0.361111 16.0873 0 15.1795 0H4.19841ZM7.17082 17.8416C6.83359 17.4615 6.86397 16.8761 7.23865 16.534L10.1568 13.8696C10.9204 13.1724 12.0796 13.1724 12.8432 13.8696L15.7614 16.534C16.136 16.8761 16.1664 17.4615 15.8292 17.8416C15.492 18.2217 14.9149 18.2526 14.5402 17.9104L11.6221 15.2461C11.5527 15.1827 11.4473 15.1827 11.3779 15.2461L8.45977 17.9104C8.08508 18.2526 7.508 18.2217 7.17082 17.8416ZM12.4127 21.6667C12.4127 22.178 12.0041 22.5926 11.5 22.5926C10.9959 22.5926 10.5873 22.178 10.5873 21.6667V17.5926C10.5873 17.0812 10.9959 16.6667 11.5 16.6667C12.0041 16.6667 12.4127 17.0812 12.4127 17.5926V21.6667Z"
      fill="rgba(77, 78, 80, 0.8)"
    />
  </svg>
);
export const LogoutIcon: React.FC = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
  >
    <path d="M20.344 17.157h-1.647a0.37 0.37 0 0 0 -0.288 0.136q-0.246 0.299 -0.525 0.574a8.3 8.3 0 0 1 -2.642 1.779 8.25 8.25 0 0 1 -3.232 0.651c-1.123 0 -2.21 -0.221 -3.232 -0.651a8.3 8.3 0 0 1 -2.642 -1.779 8.3 8.3 0 0 1 -1.782 -2.636c-0.433 -1.022 -0.651 -2.107 -0.651 -3.23s0.221 -2.208 0.651 -3.229c0.417 -0.987 1.017 -1.875 1.782 -2.636s1.653 -1.361 2.642 -1.779c1.022 -0.431 2.11 -0.651 3.232 -0.651s2.21 0.218 3.232 0.651a8.3 8.3 0 0 1 2.642 1.779c0.185 0.185 0.358 0.378 0.525 0.574a0.375 0.375 0 0 0 0.288 0.136h1.647a0.186 0.186 0 0 0 0.157 -0.288c-1.798 -2.794 -4.943 -4.643 -8.518 -4.633 -5.615 0.014 -10.118 4.572 -10.062 10.181 0.056 5.519 4.551 9.975 10.088 9.975 3.565 0 6.696 -1.847 8.492 -4.633a0.188 0.188 0 0 0 -0.157 -0.288m2.083 -5.304 -3.326 -2.624a0.188 0.188 0 0 0 -0.304 0.147v1.782H11.438a0.188 0.188 0 0 0 -0.188 0.188v1.313c0 0.103 0.085 0.188 0.188 0.188h7.359v1.782c0 0.157 0.183 0.246 0.304 0.147l3.326 -2.625a0.188 0.188 0 0 0 0 -0.295" />
  </svg>
);
export const AddButtonIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11 7.32715V14.6541"
      stroke="#FDFEFE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6699 10.9902H7.33594"
      stroke="#FDFEFE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6857 1H6.31429C3.04762 1 1 3.31208 1 6.58516V15.4148C1 18.6879 3.0381 21 6.31429 21H15.6857C18.9619 21 21 18.6879 21 15.4148V6.58516C21 3.31208 18.9619 1 15.6857 1Z"
      stroke="#FDFEFE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EditButtonIcon: React.FC = () => (
  <svg
    className="w-6 h-6 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
    />
  </svg>
);
export const ServicesIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      opacity="0.21"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
      fill="#0C7E68"
    />
    <path
      d="M37.5172 24.8229L36.7049 23.0078L34.8999 22.191C34.3971 21.9576 34.3971 21.2445 34.8999 21.0112L36.7049 20.1943L37.5172 18.3792C37.7493 17.8736 38.4584 17.8736 38.6905 18.3792L39.5027 20.1943L41.3078 21.0112C41.8106 21.2445 41.8106 21.9576 41.3078 22.191L39.5027 23.0078L38.6905 24.8229C38.4713 25.3285 37.7493 25.3285 37.5172 24.8229ZM41.6946 30.9554L41.282 30.0219C41.0499 29.5163 40.3408 29.5163 40.1087 30.0219L39.6961 30.9554L38.7549 31.3703C38.2521 31.6037 38.2521 32.3167 38.7549 32.5501L39.6832 32.965L40.0958 33.9114C40.3279 34.4171 41.037 34.4171 41.2691 33.9114L41.6817 32.978L42.6229 32.5631C43.1257 32.3297 43.1257 31.6166 42.6229 31.3832L41.6946 30.9554ZM35.1964 33.0946L36.7823 34.3004C37.298 34.6894 37.4398 35.4154 37.1175 35.9859L35.0288 39.6161C34.7065 40.1866 34.0103 40.4199 33.4172 40.1606L31.5735 39.3827C31.3156 39.5513 31.032 39.7198 30.7483 39.8624L30.5033 41.8591C30.426 42.5073 29.8716 43 29.2269 43H25.0625C24.4178 43 23.8634 42.5073 23.786 41.8591L23.5411 39.8624C23.2574 39.7198 22.9867 39.5642 22.7159 39.3827L20.8722 40.1606C20.2791 40.4199 19.5829 40.1866 19.2605 39.6161L17.1719 35.9859C16.8495 35.4154 16.9914 34.7023 17.5071 34.3004L19.0929 33.0946C19.0929 32.9391 19.0929 32.7705 19.0929 32.6149C19.0929 32.4594 19.0929 32.2908 19.1058 32.1352L17.52 30.9295C17.0043 30.5405 16.8624 29.8145 17.1848 29.244L19.2734 25.6138C19.5958 25.0433 20.292 24.8099 20.8851 25.0692L22.7288 25.8471C22.9867 25.6786 23.2703 25.51 23.554 25.3674L23.7989 23.3708C23.8634 22.7355 24.4178 22.2428 25.0625 22.2428H29.2269C29.8716 22.2428 30.426 22.7355 30.5033 23.3838L30.7483 25.3804C31.032 25.523 31.3027 25.6786 31.5735 25.8601L33.4172 25.0822C34.0103 24.8229 34.7065 25.0563 35.0288 25.6267L37.1175 29.257C37.4398 29.8274 37.298 30.5405 36.7823 30.9424L35.1964 32.1482C35.2093 32.3038 35.2093 32.4594 35.2093 32.6279C35.2093 32.7964 35.2093 32.9391 35.1964 33.0946ZM31.0191 32.6149C31.0191 30.4627 29.2914 28.7254 27.1511 28.7254C25.0109 28.7254 23.2832 30.4627 23.2832 32.6149C23.2832 34.7671 25.0109 36.5045 27.1511 36.5045C29.2914 36.5045 31.0191 34.7671 31.0191 32.6149Z"
      fill="#0C7E68"
    />
  </svg>
);
export const ServiceProvidersIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      opacity="0.21"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
      fill="#FEC53D"
    />
    <path
      d="M28.005 30.53C27.675 30.515 27.345 30.5 27 30.5C23.37 30.5 19.98 31.505 17.085 33.23C15.765 34.01 15 35.48 15 37.025V39.5C15 40.325 15.675 41 16.5 41H28.89C27.705 39.305 27 37.235 27 35C27 33.395 27.375 31.895 28.005 30.53Z"
      fill="#FEC53D"
    />
    <path
      d="M27 29C30.3137 29 33 26.3137 33 23C33 19.6863 30.3137 17 27 17C23.6863 17 21 19.6863 21 23C21 26.3137 23.6863 29 27 29Z"
      fill="#FEE1A2"
    />
    <path
      d="M43.1273 34.9996C43.1273 34.6696 43.0823 34.3696 43.0373 34.0546L44.2973 32.9596C44.5673 32.7196 44.6273 32.3296 44.4473 32.0146L43.5623 30.4846C43.3823 30.1696 43.0073 30.0346 42.6773 30.1546L41.0873 30.6946C40.6073 30.2896 40.0673 29.9746 39.4673 29.7496L39.1373 28.1146C39.0623 27.7696 38.7623 27.5146 38.4023 27.5146H36.6323C36.2723 27.5146 35.9723 27.7696 35.8973 28.1146L35.5673 29.7496C34.9673 29.9746 34.4273 30.2896 33.9473 30.6946L32.3573 30.1546C32.0123 30.0346 31.6523 30.1846 31.4723 30.4846L30.5873 32.0146C30.4073 32.3296 30.4673 32.7196 30.7373 32.9596L31.9973 34.0546C31.9523 34.3696 31.9073 34.6696 31.9073 34.9996C31.9073 35.3296 31.9523 35.6296 31.9973 35.9446L30.7373 37.0396C30.4673 37.2796 30.4073 37.6696 30.5873 37.9846L31.4723 39.5146C31.6523 39.8296 32.0273 39.9646 32.3573 39.8446L33.9473 39.3046C34.4273 39.7096 34.9673 40.0246 35.5673 40.2496L35.8973 41.8846C35.9723 42.2296 36.2723 42.4846 36.6323 42.4846H38.4023C38.7623 42.4846 39.0623 42.2296 39.1373 41.8846L39.4673 40.2496C40.0673 40.0246 40.6073 39.7096 41.0873 39.3046L42.6773 39.8446C43.0223 39.9646 43.3823 39.8146 43.5623 39.5146L44.4473 37.9846C44.6273 37.6696 44.5673 37.2796 44.2973 37.0396L43.0373 35.9446C43.0823 35.6296 43.1273 35.3296 43.1273 34.9996ZM37.5023 37.9996C35.8523 37.9996 34.5023 36.6496 34.5023 34.9996C34.5023 33.3496 35.8523 31.9996 37.5023 31.9996C39.1523 31.9996 40.5023 33.3496 40.5023 34.9996C40.5023 36.6496 39.1523 37.9996 37.5023 37.9996Z"
      fill="#FEC53D"
    />
  </svg>
);
export const TotalUsersIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      opacity="0.21"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 30V37C0 49.7025 10.2974 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z"
      fill="#8280FF"
    />
    <path
      opacity="0.587821"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.6641 23.3333C20.6641 26.2789 23.0519 28.6667 25.9974 28.6667C28.9429 28.6667 31.3307 26.2789 31.3307 23.3333C31.3307 20.3878 28.9429 18 25.9974 18C23.0519 18 20.6641 20.3878 20.6641 23.3333ZM33.9975 28.6665C33.9975 30.8756 35.7883 32.6665 37.9975 32.6665C40.2066 32.6665 41.9975 30.8756 41.9975 28.6665C41.9975 26.4574 40.2066 24.6665 37.9975 24.6665C35.7883 24.6665 33.9975 26.4574 33.9975 28.6665Z"
      fill="#8280FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.9778 31.333C19.6825 31.333 14.5177 34.5684 14.0009 40.9319C13.9727 41.2786 14.6356 41.9997 14.97 41.9997H36.9956C37.9972 41.9997 38.0128 41.1936 37.9972 40.933C37.6065 34.3906 32.3616 31.333 25.9778 31.333ZM37.4678 34.0005C39.1414 36.2288 40.1331 38.9984 40.1331 41.9997H45.2748C45.9982 41.9997 46.0094 41.3951 45.9982 41.1997C45.7191 36.3463 42.0101 34.0499 37.4678 34.0005Z"
      fill="#8280FF"
    />
  </svg>
);

export const RevenueIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="68"
    viewBox="0 0 70 68"
    fill="none"
  >
    <path
      opacity="0.21"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 33.5294V44.0588C0 56.7614 10.2975 67.0588 23 67.0588H34.6947H46.3893C59.0919 67.0588 69.3893 56.7614 69.3893 44.0588V33.5294V23C69.3893 10.2974 59.0919 0 46.3893 0H34.6947H23C10.2975 0 0 10.2974 0 23V33.5294Z"
      fill="#4E96FF"
    />
    <ellipse cx="35" cy="33.5" rx="15" ry="15.5" fill="#4E96FF" />
    <path
      d="M30 25H42M30 30H42M38.5 43L30 35H33C39.667 35 39.667 25 33 25"
      stroke="#EEEEEE"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const MasterDataIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
  >
    <path
      d="M9.82143 8.92857C9.18899 8.92857 8.51935 8.90067 7.8125 8.84487C7.10565 8.78906 6.39416 8.68676 5.67801 8.53795C4.96187 8.38914 4.26897 8.19847 3.59933 7.96596C2.92969 7.73345 2.32515 7.44513 1.78571 7.10101V20.5357C1.78571 20.7496 1.87407 20.9496 2.05078 21.1356C2.22749 21.3216 2.45071 21.503 2.72042 21.6797C2.99014 21.8564 3.29706 22.0052 3.64118 22.1261C3.98531 22.247 4.31548 22.3633 4.6317 22.4749C4.94792 22.5865 5.24554 22.6702 5.52455 22.726C5.80357 22.7818 6.01749 22.8283 6.16629 22.8655C6.62202 22.9492 7.07775 23.0143 7.53348 23.0608C7.98921 23.1073 8.45424 23.1445 8.92857 23.1724V24.986C8.51935 24.9674 8.01711 24.9256 7.42188 24.8605C6.82664 24.7954 6.1942 24.6931 5.52455 24.5536C4.85491 24.4141 4.19457 24.2327 3.54353 24.0095C2.89249 23.7863 2.3019 23.5119 1.77176 23.1864C1.24163 22.8609 0.813802 22.4795 0.488281 22.0424C0.16276 21.6053 0 21.1031 0 20.5357V4.46429C0 4.02716 0.102307 3.62723 0.30692 3.26451C0.511533 2.90179 0.78125 2.58092 1.11607 2.3019C1.45089 2.02288 1.83687 1.76711 2.274 1.5346C2.71112 1.30208 3.1529 1.11142 3.59933 0.962612C4.04576 0.813802 4.48754 0.683594 4.92466 0.571987C5.36179 0.460379 5.75242 0.376674 6.09654 0.320871C6.71038 0.209263 7.32887 0.130208 7.95201 0.0837054C8.57515 0.0372024 9.19829 0.0093006 9.82143 0C10.4446 0 11.0677 0.0232515 11.6908 0.0697545C12.314 0.116257 12.9325 0.199963 13.5463 0.320871C13.8811 0.385975 14.2671 0.46968 14.7042 0.571987C15.1414 0.674293 15.5831 0.804502 16.0296 0.962612C16.476 1.12072 16.9178 1.31138 17.3549 1.5346C17.792 1.75781 18.178 2.00893 18.5128 2.28795C18.8477 2.56696 19.122 2.89249 19.3359 3.26451C19.5499 3.63653 19.6522 4.03646 19.6429 4.46429V10.7143H17.8571V7.10101C17.3084 7.44513 16.7039 7.73345 16.0435 7.96596C15.3832 8.19847 14.6949 8.38449 13.9788 8.524C13.2626 8.6635 12.5512 8.76581 11.8443 8.83092C11.1375 8.89602 10.4632 8.92857 9.82143 8.92857ZM9.82143 1.78571C9.29129 1.78571 8.68676 1.81362 8.00781 1.86942C7.32887 1.92522 6.64062 2.01823 5.94308 2.14844C5.24554 2.27865 4.58054 2.46466 3.9481 2.70647C3.31566 2.94829 2.78088 3.24126 2.34375 3.58538C2.21354 3.68769 2.08798 3.81324 1.96708 3.96205C1.84617 4.11086 1.78571 4.27827 1.78571 4.46429C1.78571 4.641 1.84617 4.80376 1.96708 4.95257C2.08798 5.10138 2.21354 5.23159 2.34375 5.34319C2.77158 5.69661 3.30171 5.98958 3.93415 6.2221C4.56659 6.45461 5.23158 6.63597 5.92913 6.76618C6.62667 6.89639 7.31492 6.99405 7.99386 7.05915C8.6728 7.12426 9.28199 7.15216 9.82143 7.14286C10.3516 7.14286 10.9561 7.11496 11.635 7.05915C12.314 7.00335 13.0022 6.91034 13.6998 6.78013C14.3973 6.64993 15.0623 6.46391 15.6948 6.2221C16.3272 5.98028 16.8573 5.68731 17.2852 5.34319C17.4154 5.24089 17.5409 5.11533 17.6618 4.96652C17.7827 4.81771 17.8478 4.6503 17.8571 4.46429C17.8571 4.28757 17.7967 4.12481 17.6758 3.976C17.5549 3.8272 17.4247 3.69699 17.2852 3.58538C16.8573 3.23196 16.3272 2.93899 15.6948 2.70647C15.0623 2.47396 14.402 2.2926 13.7137 2.16239C13.0255 2.03218 12.3372 1.93452 11.649 1.86942C10.9608 1.80432 10.3516 1.77641 9.82143 1.78571ZM25 12.0954V26.7857H10.7143V12.1512L14.9554 17.7455L17.885 12.4442L20.8287 17.7455L25 12.0954ZM23.2143 17.5223L20.6194 21.0519L17.885 16.1272L15.1786 21.01L12.5 17.4665V25H23.2143V17.5223Z"
      fill="rgba(77, 78, 80, 0.8)"
    />
  </svg>
);
export const JobTitleIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="23"
    viewBox="0 0 21 23"
    fill="none"
  >
    <path
      d="M12.4446 9.33317H17.8889V10.8887H12.4446V9.33317ZM12.4446 5.44435H21V6.99988H12.4446V5.44435ZM12.4446 1.55553H21V3.11106H12.4446V1.55553ZM6.22249 22.5552H3.11143C2.69926 22.5539 2.30432 22.3896 2.01287 22.0982C1.72142 21.8067 1.55714 21.4118 1.55591 20.9996V15.5553C1.14373 15.554 0.748792 15.3898 0.457341 15.0983C0.165889 14.8069 0.00160854 14.4119 0.000377552 13.9997V9.33317C-0.00521239 9.02522 0.0513209 8.7193 0.166601 8.43368C0.281881 8.14807 0.453542 7.88862 0.671332 7.67083C0.889122 7.45304 1.14857 7.28138 1.43419 7.1661C1.7198 7.05082 2.02572 6.99429 2.33367 6.99988H7.00025C7.3082 6.99429 7.61412 7.05082 7.89973 7.1661C8.18535 7.28138 8.4448 7.45304 8.66259 7.67083C8.88038 7.88862 9.05204 8.14807 9.16732 8.43368C9.2826 8.7193 9.33913 9.02522 9.33354 9.33317V13.9997C9.33231 14.4119 9.16803 14.8069 8.87658 15.0983C8.58513 15.3898 8.19019 15.554 7.77802 15.5553V20.9996C7.77678 21.4118 7.6125 21.8067 7.32105 22.0982C7.0296 22.3896 6.63466 22.5539 6.22249 22.5552ZM2.33367 8.5554C2.2299 8.54917 2.126 8.56501 2.02881 8.60189C1.93162 8.63877 1.84336 8.69585 1.76985 8.76935C1.69635 8.84286 1.63927 8.93112 1.60239 9.02831C1.56551 9.1255 1.54967 9.2294 1.55591 9.33317V13.9997H3.11143V20.9996H6.22249V13.9997H7.77802V9.33317C7.78425 9.2294 7.76841 9.1255 7.73153 9.02831C7.69465 8.93112 7.63757 8.84286 7.56407 8.76935C7.49056 8.69585 7.4023 8.63877 7.30511 8.60189C7.20792 8.56501 7.10402 8.54917 7.00025 8.5554H2.33367ZM4.66696 6.22211C4.05165 6.22211 3.45016 6.03965 2.93855 5.6978C2.42694 5.35596 2.02819 4.87008 1.79272 4.30161C1.55725 3.73313 1.49564 3.10761 1.61568 2.50412C1.73572 1.90063 2.03202 1.3463 2.46711 0.911208C2.9022 0.47612 3.45654 0.17982 4.06002 0.0597794C4.66351 -0.0602613 5.28904 0.00134796 5.85751 0.236816C6.42598 0.472285 6.91186 0.871036 7.25371 1.38265C7.59555 1.89426 7.77802 2.49575 7.77802 3.11106C7.77596 3.93553 7.44753 4.72565 6.86454 5.30864C6.28155 5.89163 5.49143 6.22006 4.66696 6.22211ZM4.66696 1.55553C4.35931 1.55553 4.05856 1.64676 3.80276 1.81768C3.54695 1.98861 3.34757 2.23155 3.22984 2.51578C3.11211 2.80002 3.0813 3.11278 3.14132 3.41453C3.20134 3.71627 3.34949 3.99344 3.56704 4.21098C3.78458 4.42853 4.06175 4.57667 4.36349 4.6367C4.66523 4.69672 4.978 4.66591 5.26223 4.54818C5.54647 4.43044 5.78941 4.23107 5.96033 3.97526C6.13126 3.71946 6.22249 3.41871 6.22249 3.11106C6.22126 2.69888 6.05698 2.30394 5.76552 2.01249C5.47407 1.72104 5.07913 1.55676 4.66696 1.55553Z"
      fill="#396B61"
    />
  </svg>
);
export const IndustriesIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
  >
    <path
      d="M16.8 12.6H14.7V14.7H16.8M16.8 8.4H14.7V10.5H16.8M18.9 16.8H10.5V14.7H12.6V12.6H10.5V10.5H12.6V8.4H10.5V6.3H18.9M8.4 4.2H6.3V2.1H8.4M8.4 8.4H6.3V6.3H8.4M8.4 12.6H6.3V10.5H8.4M8.4 16.8H6.3V14.7H8.4M4.2 4.2H2.1V2.1H4.2M4.2 8.4H2.1V6.3H4.2M4.2 12.6H2.1V10.5H4.2M4.2 16.8H2.1V14.7H4.2M10.5 4.2V0H0V18.9H21V4.2H10.5Z"
      fill="#396B61"
    />
  </svg>
);
export const DesignationsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3161 7.63654C14.3161 8.64919 13.9138 9.62036 13.1977 10.3364C12.4817 11.0525 11.5105 11.4547 10.4979 11.4547C9.48522 11.4547 8.51405 11.0525 7.79801 10.3364C7.08196 9.62036 6.67969 8.64919 6.67969 7.63654C6.67969 6.6239 7.08196 5.65273 7.79801 4.93668C8.51405 4.22063 9.48522 3.81836 10.4979 3.81836C11.5105 3.81836 12.4817 4.22063 13.1977 4.93668C13.9138 5.65273 14.3161 6.6239 14.3161 7.63654ZM12.407 7.63654C12.407 8.14286 12.2058 8.62845 11.8478 8.98647C11.4898 9.3445 11.0042 9.54563 10.4979 9.54563C9.99155 9.54563 9.50596 9.3445 9.14794 8.98647C8.78991 8.62845 8.58878 8.14286 8.58878 7.63654C8.58878 7.13022 8.78991 6.64463 9.14794 6.28661C9.50596 5.92859 9.99155 5.72745 10.4979 5.72745C11.0042 5.72745 11.4898 5.92859 11.8478 6.28661C12.2058 6.64463 12.407 7.13022 12.407 7.63654Z"
      fill="#396B61"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 0C4.70114 0 0 4.70114 0 10.5C0 16.2989 4.70114 21 10.5 21C16.2989 21 21 16.2989 21 10.5C21 4.70114 16.2989 0 10.5 0ZM1.90909 10.5C1.90909 12.495 2.58968 14.3315 3.73036 15.7901C4.53165 14.7383 5.56515 13.8859 6.7502 13.2994C7.93525 12.7129 9.23981 12.4082 10.562 12.4091C11.8673 12.4076 13.1556 12.7041 14.3288 13.2762C15.502 13.8482 16.5291 14.6806 17.3317 15.7099C18.1587 14.6252 18.7156 13.3591 18.9562 12.0164C19.1968 10.6737 19.1142 9.29301 18.7153 7.98858C18.3164 6.68414 17.6125 5.49345 16.6621 4.51504C15.7116 3.53662 14.5418 2.79859 13.2495 2.36203C11.9571 1.92547 10.5794 1.80292 9.23032 2.00452C7.88123 2.20612 6.59953 2.72608 5.49128 3.52137C4.38303 4.31666 3.48009 5.36442 2.85717 6.57796C2.23425 7.7915 1.90926 9.13592 1.90909 10.5ZM10.5 19.0909C8.52782 19.0941 6.61514 18.4156 5.08582 17.1704C5.70132 16.2889 6.52068 15.5693 7.47416 15.0727C8.42764 14.5761 9.487 14.3173 10.562 14.3182C11.6237 14.3173 12.6702 14.5697 13.6147 15.0544C14.5591 15.5392 15.3743 16.2424 15.9925 17.1055C14.4513 18.3912 12.5071 19.094 10.5 19.0909Z"
      fill="#396B61"
    />
  </svg>
);
export const QualificationsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="23"
    viewBox="0 0 21 23"
    fill="none"
  >
    <path
      d="M18.9 0H2.1C0.945 0 0 0.945 0 2.1V20.3C0 21.455 0.945 22.4 2.1 22.4H18.9C20.055 22.4 21 21.455 21 20.3V2.1C21 0.945 20.055 0 18.9 0ZM18.2 19.6H2.8V2.8H18.2V19.6ZM5.6 12.6H15.4V14H5.6V12.6ZM5.6 15.4H15.4V16.8H5.6V15.4ZM7 6.3C7.00009 6.02413 7.05452 5.75098 7.16017 5.49615C7.26583 5.24132 7.42064 5.00979 7.61578 4.81479C7.81091 4.61978 8.04254 4.46512 8.29744 4.35964C8.55235 4.25415 8.82553 4.19991 9.1014 4.2C9.37727 4.20009 9.65042 4.25452 9.90525 4.36017C10.1601 4.46583 10.3916 4.62064 10.5866 4.81578C10.7816 5.01091 10.9363 5.24254 11.0418 5.49744C11.1472 5.75235 11.2015 6.02553 11.2014 6.3014C11.2012 6.85854 10.9797 7.39279 10.5856 7.78661C10.1915 8.18044 9.65714 8.40159 9.1 8.4014C8.54286 8.40121 8.00861 8.17971 7.61479 7.78562C7.22096 7.39154 6.99981 6.85714 7 6.3ZM10.5 8.4H7.7C6.545 8.4 5.6 9.03 5.6 9.8V11.2H12.6V9.8C12.6 9.03 11.655 8.4 10.5 8.4Z"
      fill="#396B61"
    />
  </svg>
);
export const JobTypesIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
  >
    <path
      d="M10.4573 20.9487H8.9852C5.22097 20.9487 3.33939 20.9487 2.16969 19.757C1 18.5652 1 16.6469 1 12.8113C1 8.97565 1 7.05731 2.16969 5.86557C3.33939 4.67383 5.22097 4.67383 8.9852 4.67383H12.9783C16.7426 4.67383 18.6252 4.67383 19.7949 5.86557C20.6947 6.78222 20.9016 8.12936 20.9499 10.4488V12.0238"
      stroke="#396B61"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8499 17.7999H15.6999M15.6999 20.9499C14.8645 20.9499 14.0633 20.618 13.4726 20.0273C12.8818 19.4365 12.55 18.6353 12.55 17.7999C12.55 16.9645 12.8818 16.1633 13.4726 15.5725C14.0633 14.9818 14.8645 14.6499 15.6999 14.6499M18.8499 20.9499C19.6854 20.9499 20.4866 20.618 21.0773 20.0273C21.668 19.4365 21.9999 18.6353 21.9999 17.7999C21.9999 16.9645 21.668 16.1633 21.0773 15.5725C20.4866 14.9818 19.6854 14.6499 18.8499 14.6499M15.6999 4.67498L15.5949 4.34948C15.0752 2.73249 14.8158 1.92399 14.1974 1.462C13.5779 1 12.7568 1 11.1125 1H10.8364C9.19313 1 8.37099 1 7.75254 1.462C7.13304 1.92399 6.8737 2.73249 6.35395 4.34948L6.25 4.67498"
      stroke="#396B61"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const TableFilterIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.67857 9.69231C2.5365 9.69232 2.40024 9.74906 2.29978 9.85004C2.19932 9.95101 2.14287 10.088 2.14286 10.2308V11.3077H0.535714C0.393634 11.3077 0.257373 11.3644 0.156907 11.4654C0.0564408 11.5664 0 11.7033 0 11.8462C0 11.989 0.0564408 12.1259 0.156907 12.2269C0.257373 12.3279 0.393634 12.3846 0.535714 12.3846H2.14286V13.4615C2.14287 13.6043 2.19932 13.7413 2.29978 13.8423C2.40024 13.9433 2.5365 14 2.67857 14H4.28571C4.42779 14 4.56404 13.9433 4.66451 13.8423C4.76497 13.7413 4.82141 13.6043 4.82143 13.4615V12.3846H14.4643C14.6064 12.3846 14.7426 12.3279 14.8431 12.2269C14.9436 12.1259 15 11.989 15 11.8462C15 11.7033 14.9436 11.5664 14.8431 11.4654C14.7426 11.3644 14.6064 11.3077 14.4643 11.3077H4.82143V10.2308C4.82141 10.088 4.76497 9.95101 4.66451 9.85004C4.56404 9.74906 4.42779 9.69232 4.28571 9.69231H2.67857ZM10.7143 4.84615C10.5722 4.84617 10.436 4.9029 10.3355 5.00388C10.235 5.10486 10.1786 5.24181 10.1786 5.38462V6.46154H0.535714C0.393634 6.46154 0.257373 6.51827 0.156907 6.61925C0.0564408 6.72023 0 6.85719 0 7C0 7.14281 0.0564408 7.27977 0.156907 7.38075C0.257373 7.48173 0.393634 7.53846 0.535714 7.53846H10.1786V8.61539C10.1786 8.75819 10.235 8.89514 10.3355 8.99612C10.436 9.0971 10.5722 9.15383 10.7143 9.15385H12.3214C12.4635 9.15383 12.5998 9.0971 12.7002 8.99612C12.8007 8.89514 12.8571 8.75819 12.8571 8.61539V7.53846H14.4643C14.6064 7.53846 14.7426 7.48173 14.8431 7.38075C14.9436 7.27977 15 7.14281 15 7C15 6.85719 14.9436 6.72023 14.8431 6.61925C14.7426 6.51827 14.6064 6.46154 14.4643 6.46154H12.8571V5.38462C12.8571 5.24181 12.8007 5.10486 12.7002 5.00388C12.5998 4.9029 12.4635 4.84617 12.3214 4.84615H10.7143ZM2.67857 0C2.5365 1.42783e-05 2.40024 0.0567497 2.29978 0.157728C2.19932 0.258706 2.14287 0.395657 2.14286 0.538462V1.61538H0.535714C0.393634 1.61538 0.257373 1.67211 0.156907 1.7731C0.0564408 1.87408 0 2.01104 0 2.15385C0 2.29666 0.0564408 2.43362 0.156907 2.5346C0.257373 2.63558 0.393634 2.69231 0.535714 2.69231H2.14286V3.76923C2.14287 3.91204 2.19932 4.04899 2.29978 4.14996C2.40024 4.25094 2.5365 4.30768 2.67857 4.30769H4.28571C4.42779 4.30768 4.56404 4.25094 4.66451 4.14996C4.76497 4.04899 4.82141 3.91204 4.82143 3.76923V2.69231H14.4643C14.6064 2.69231 14.7426 2.63558 14.8431 2.5346C14.9436 2.43362 15 2.29666 15 2.15385C15 2.01104 14.9436 1.87408 14.8431 1.7731C14.7426 1.67211 14.6064 1.61538 14.4643 1.61538H4.82143V0.538462C4.82141 0.395657 4.76497 0.258706 4.66451 0.157728C4.56404 0.0567497 4.42779 1.42783e-05 4.28571 0H2.67857Z"
      fill="#575859"
    />
  </svg>
);

export const TableEditColumnIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
  >
    <path
      d="M5.016 1.99805C3.68567 1.99805 2.40983 2.57751 1.46915 3.60896C0.52847 4.64041 0 6.03936 0 7.49805C0 8.95674 0.52847 10.3557 1.46915 11.3871C2.40983 12.4186 3.68567 12.998 5.016 12.998C6.34633 12.998 7.62217 12.4186 8.56285 11.3871C9.50353 10.3557 10.032 8.95674 10.032 7.49805C10.032 6.03936 9.50353 4.64041 8.56285 3.60896C7.62217 2.57751 6.34633 1.99805 5.016 1.99805ZM7.296 8.49805H5.928V9.99805C5.928 10.2633 5.83191 10.5176 5.66088 10.7052C5.48985 10.8927 5.25788 10.998 5.016 10.998C4.77412 10.998 4.54215 10.8927 4.37112 10.7052C4.20009 10.5176 4.104 10.2633 4.104 9.99805V8.49805H2.736C2.49412 8.49805 2.26215 8.39269 2.09112 8.20515C1.92009 8.01762 1.824 7.76326 1.824 7.49805C1.824 7.23283 1.92009 6.97848 2.09112 6.79094C2.26215 6.6034 2.49412 6.49805 2.736 6.49805H4.104V4.99805C4.104 4.73283 4.20009 4.47848 4.37112 4.29094C4.54215 4.1034 4.77412 3.99805 5.016 3.99805C5.25788 3.99805 5.48985 4.1034 5.66088 4.29094C5.83191 4.47848 5.928 4.73283 5.928 4.99805V6.49805H7.296C7.53788 6.49805 7.76985 6.6034 7.94088 6.79094C8.11191 6.97848 8.208 7.23283 8.208 7.49805C8.208 7.76326 8.11191 8.01762 7.94088 8.20515C7.76985 8.39269 7.53788 8.49805 7.296 8.49805Z"
      fill="#575859"
    />
    <path d="M22.7993 13H10.0312H22.7993Z" fill="#575859" />
    <path
      d="M22.7993 13H10.0312"
      stroke="#575859"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path d="M22.8034 9.00195H11.8594H22.8034Z" fill="#575859" />
    <path
      d="M22.8034 9.00195H11.8594"
      stroke="#575859"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path d="M22.8034 4.99805H11.8594H22.8034Z" fill="#575859" />
    <path
      d="M22.8034 4.99805H11.8594"
      stroke="#575859"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path d="M22.7993 1H10.0312H22.7993Z" fill="#575859" />
    <path
      d="M22.7993 1H10.0312"
      stroke="#575859"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
);

export const TableCloseIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M1.85885 0.306L6.23352 4.68067L10.5855 0.328667C10.6816 0.226346 10.7975 0.144494 10.926 0.0880172C11.0545 0.0315405 11.1931 0.00160292 11.3335 0C11.6341 0 11.9224 0.119404 12.1349 0.331946C12.3474 0.544487 12.4669 0.832755 12.4669 1.13333C12.4695 1.27228 12.4437 1.41031 12.3911 1.53893C12.3385 1.66756 12.2601 1.78408 12.1608 1.88133L7.75218 6.23333L12.1608 10.642C12.3476 10.8247 12.4572 11.0722 12.4669 11.3333C12.4669 11.6339 12.3474 11.9222 12.1349 12.1347C11.9224 12.3473 11.6341 12.4667 11.3335 12.4667C11.1891 12.4727 11.045 12.4486 10.9103 12.3959C10.7757 12.3432 10.6535 12.2631 10.5515 12.1607L6.23352 7.786L1.87018 12.1493C1.77442 12.2482 1.66002 12.3272 1.53359 12.3817C1.40715 12.4361 1.27118 12.465 1.13352 12.4667C0.832939 12.4667 0.544671 12.3473 0.33213 12.1347C0.119589 11.9222 0.000184401 11.6339 0.000184401 11.3333C-0.00245796 11.1944 0.0233219 11.0564 0.075942 10.9277C0.128562 10.7991 0.206912 10.6826 0.306184 10.5853L4.71485 6.23333L0.306184 1.82467C0.119394 1.64193 0.00986263 1.39447 0.000184401 1.13333C0.000184401 0.832755 0.119589 0.544487 0.33213 0.331946C0.544671 0.119404 0.832939 0 1.13352 0C1.40552 0.0034 1.66618 0.113333 1.85885 0.306Z"
      fill="#575859"
    />
  </svg>
);

const SvgIcons = {
  DashBoardIcon,
  BillingIcon,
  ServiceProviderIcon,
  SettingsIcon,
  OrganizationIcon,
  PersonalDetailsIcon,
  PlatformProvidersIcon,
  UserControlsIcon,
  UsersIcon,
  RolesIcon,
  FileUploadIcon,
  LogoutIcon,
  AddButtonIcon,
  EditButtonIcon,
  ServicesIcon,
  ServiceProvidersIcon,
  TotalUsersIcon,
  RevenueIcon,
  MasterDataIcon,
  JobTitleIcon,
  JobTypesIcon,
  QualificationsIcon,
  DesignationsIcon,
  IndustriesIcon,
  TableFilterIcon,
  TableEditColumnIcon,
  TableCloseIcon,
};
export default SvgIcons;
